import { Campaign, CampaignOutlined, Download } from "@mui/icons-material";
import { saveAs } from "file-saver";
import React, { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { MdFilterList } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import CountDownTimer from "../../DashBoard/countDownTimer";
import ChatIcon from "@mui/icons-material/Chat";
import moment from "moment";
import {
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  SwipeableDrawer,
} from "@mui/material";
import ListingsSearchFilter from "../../DashBoard/ListingsSearch/listingsSearchFilter";
import { BankingSlot } from "./bankingSlot";
import BankingRequestModal from "./bankingRequestModal";
import EnergyConsumptionCurve from "./energyConsumptionCurve";
import ReceivedBankingRequests from "./receivedBankingRequests";
import { useNavigate, useNavigation } from "react-router-dom";
import Styles from "../../../Styles/Banking/bankingList.module.css";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import EditIcon from "@mui/icons-material/Edit";
import ListIcon from "@mui/icons-material/List";
import bankingService from "../../../components/Services/banking.service";
import { getBankingCapacityall } from "../../../store/Banking/actions";
import FilterSection from "../../../components/CommonDashboard/FilterSection";
import PreviewIcon from "@mui/icons-material/Preview";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import FilterListIcon from "@mui/icons-material/FilterList";
import { getSelectedCapacityData } from "../../../store/DashBoard/actions";
import { disableButton, enableButton } from "../../../store/ButtonFlag/actions";
import documentUploadService from "../../../components/Services/documentUpload.service";
import chatService from "../../../components/Services/chat.service";
import Chat from "../../../components/chat/Chat";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UploadedDocument from "../../Documents/UploadedDocument";
import BankViewModal from "./BankViewModal/BankViewModal";
export default function renderSlotDetails(
  slotData,
  itemType,
  itemId,
  showDetails
) {
  return (
    <div className="d-block">
      <div className="d-flex">
        <div>
          <div>{slotData[0]?.dateStartAt}</div>
        </div>
        <div>-</div>
        <div>
          <div>{slotData[0]?.dateEndAt}</div>
        </div>
        /
        <div>
          <div>{slotData[0]?.slotStartAt}</div>
        </div>
        <div>-</div>
        <div>
          <div>
            {slotData[0]?.slotEndAt === "23:59"
              ? "24:00"
              : slotData[0]?.slotEndAt}
          </div>
        </div>
      </div>
      {showDetails[itemType]?.[itemId] &&
        slotData.slice(1).map((item, index) => (
          <div style={{ display: "flex" }} key={index}>
            <div>
              <div>{item.dateStartAt}</div>
            </div>
            <div>-</div>
            <div>
              <div>{item.dateEndAt}</div>
            </div>
            /
            <div>
              <div>{item.slotStartAt}</div>
            </div>
            <div>-</div>
            <div>
              <div>{item.slotEndAt === "23:59" ? "24:00" : item.slotEndAt}</div>
            </div>
          </div>
        ))}
    </div>
  );
}
export const Banking = () => {
  const configKey = useSelector((state) => state?.sessionState?.connectionName);
  const allBankListings = useSelector(
    (state) => state?.bankingCapacityReducer?.allBankingCapacity
  );
  const isButtonEnabled = useSelector(
    (state) => state?.buttonReducer?.isButtonEnabled
  );
  const unreadNotificationsObj = useSelector(
    (state) => state?.notificationReducer?.unreadNotifications
  );
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const [statusDropDownValue, setStatusDropDownValue] = useState("");
  const [sortingItems, setSortingItems] = useState([
    {
      name: "Banking Factor",
      key: "bankingFactor",
      value: "",
      clickCount: 0,
    },
    {
      name: "Time of Drawal Factor",
      key: "timeOfDrawlFactor",
      value: "",
      clickCount: 0,
    },
    {
      name: "Quantity (MW)",
      key: "requiredQty",
      value: "",
      clickCount: 0,
    },
  ]);
  const [isModel, setIsModel] = useState(false);
  const [isAddBankingRequest, setIsAddBankingRequest] = useState(false);
  const [isCurveModal, setIsCurveModal] = useState(false);
  const [showDetails, setShowDetails] = useState({});
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const [selectedCardData, setSelectedCardData] = useState(null);
  const [matchingProfiles, setMatchingProfiles] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isReceivedBankModal, setIsReceivedBankModal] = useState(false);
  const [docData, setDocData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [fromUserCapName, setFromUserCapName] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [acceptedCapData, setAcceptedCapData] = useState(null);
  const [isOpenChat, setOpenChat] = useState(false);
  const [UserCapName, setUserCapName] = useState(null);
  const [duplicate, setDuplicate] = useState(false);
  const [isPdfOpen, setIsPdfOpen] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState(null);

  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [viewData, setViewData] = useState({});

  const formikRef = useRef();

  const open = Boolean(anchorEl);

  const handleBankingsReceived = (item) => {
    getSelectedCapacityData(item)(dispatch);
    navigation("/bankingRequests_received");
  };
  const getMatchingBankingListings = (id, reqBody) => {
    setLoader(true);
    bankingService
      .getMatchingBankingListings(id, reqBody)
      .then((response) => {
        if (response?.data?.code === 200) {
          setLoader(false);
          setMatchingProfiles(response?.data?.data);
        } else {
          setLoader(false);
        }
      })
      .catch((err) => console.log("Api call Error: ", err));
  };
  const handleSortClick = (key) => {
    let sortingItemsCopy = sortingItems.map((item) => {
      if (item.key === key) {
        const newClickCount = item.clickCount + 1;
        let newValue = "";

        switch (newClickCount % 3) {
          case 1:
            newValue = "ASC";
            break;
          case 2:
            newValue = "DESC";
            break;
          case 0:
            newValue = "";
            break;
          default:
            break;
        }

        return { ...item, value: newValue, clickCount: newClickCount };
      }
      return item;
    });

    setSortingItems(sortingItemsCopy);
    const sort = sortingItemsCopy.reduce((acc, item) => {
      if (item.value !== "") {
        acc[item.key] = item.value;
      }
      return acc;
    }, {});
    console.log("sortingItemsCopy====>", { sortingItemsCopy, sort });

    const reqBody = { sort };
    getMatchingBankingListings(selectedCardData?.id, reqBody);
  };
  const handleFilterDropdown = (value) => {
    setStatusDropDownValue(value);
    const requestBody = {
      search: [
        value !== "" && {
          operation: "LIKE",
          key: "againstBankingListingConnections_status",
          value: value,
          value1: null,
        },
      ].filter(Boolean),
    };
    if (allBankListings?.length > 0) {
      getMatchingBankingListings(selectedCardData?.id, requestBody);
    }
  };
  const getDocDataById = (id) => {
    documentUploadService
      .getDocumentById(id)
      .then((response) => {
        if (response?.data?.code === 200) {
          setDocData(response?.data?.data);
        }
      })
      .catch((err) => console.log("Api call Error:", err));
  };
  const handleAddNewSlot = (e) => {
    setIsModel(true);
  };
  const handleEditClick = (item, type) => {
    if (type === "duplicate") {
      setDuplicate(true);
    } else {
      setDuplicate(false);
    }
    setIsModel(item);
    item && item?.tenderDocumentId && getDocDataById(item?.tenderDocumentId);
  };

  const handleAddBids = (item) => {
    setIsAddBankingRequest(item);
  };

  const closeAddsBidsModal = () => {
    setIsAddBankingRequest(false);
  };
  const openCurveModal = () => {
    setIsCurveModal(true);
  };
  const closeCurveModal = () => {
    setIsCurveModal(false);
  };
  const toggleDrawer = (value) => {
    setOpenDrawer(value);
  };

  const handleSelectCard = (data, index) => {
    setSelectedCardIndex(index);
    setSelectedCardData(data);
    getMatchingBankingListings(data?.id);
    setStatusDropDownValue("");
  };

  function handleShowDetails(type, index, e, data) {
    e.stopPropagation();
    setViewData(data);
    setTimeout(() => {
      setViewMoreModal(true);
    }, 1000);
  }

  useEffect(() => {
    getBankingCapacityall()(dispatch);
  }, []);
  useEffect(() => {
    if (allBankListings && allBankListings.length > 0) {
      setSelectedCardData(allBankListings[0]);
      setSelectedCardIndex(0);
      getMatchingBankingListings(allBankListings[0]?.id);
    } else {
      setMatchingProfiles(null);
    }
  }, [allBankListings]);

  const handleViewConnection = (item) => {
    disableButton()(dispatch);
    let connectionId = selectedCardData?.id;
    let connectionAgainstId = item?.id;
    bankingService
      .viewSentBankingConnection(connectionId, connectionAgainstId)
      .then((response) => {
        if (response?.data?.code === 200) {
          setIsReceivedBankModal(response?.data?.data);
          enableButton()(dispatch);
        } else if (response?.data?.code !== 200) {
          enableButton()(dispatch);
        }
      })
      .catch((err) => {
        console.log("Api Call Error:", err);
        enableButton()(dispatch);
      });
  };
  const closeViewConnectionModal = () => {
    enableButton()(dispatch);
    setIsReceivedBankModal(false);
  };
  useEffect(() => {
    let bodyElem = document.body;
    bodyElem.classList.add("custom-body-overflow");
    return () => {
      bodyElem.classList.remove("custom-body-overflow");
    };
  }, []);
  const handleViewProfile = (item) => {
    localStorage.setItem("companyId", item?.company?.companyId);
    navigation("/company_profile");
  };
  const handleChatClick = (event, item) => {
    setFromUserCapName(item?.name);
    setAnchorEl(event.currentTarget);
    setAcceptedCapData(null);
    chatService.getAllChatAcceptedBankingListing(item?.id).then((response) => {
      if (response?.data?.code === 200) {
        setAcceptedCapData(response?.data?.data);
      }
    });
  };
  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleCapNameClick = (e, capName) => {
    e.stopPropagation();
    setAnchorEl(null);
    setUserCapName({
      fromUser: fromUserCapName,
      toUser: capName,
    });
    setOpenChat(true);
  };

  const handleViewFile = (item, e) => {
    e.stopPropagation();
    getDocDataById2(item, true);
  };
  const handleClosePDFModal = () => {
    setIsPdfOpen(false);
  };

  const getDocDataById2 = (id, viewFile) => {
    documentUploadService
      .getDocumentById(id)
      .then((response) => {
        if (response?.data?.code === 200) {
          if (viewFile) {
            let fileTypeSplit = response?.data?.data?.fileName.split(".");
            setSelectedFiles(fileTypeSplit[fileTypeSplit?.length - 1]);
            setSelectedFileData(response?.data?.data?.fileInBytes);
            setIsPdfOpen(true);
          }
        }
      })
      .catch((err) => console.log("Api call Error:", err));
  };

  const checkRenderType = (date1, date2) => {
    let first = new Date(date1);
    let second = new Date(date2);

    if (first < second) {
      return true;
    } else {
      return false;
    }
  };

  const handleDownloadListing = async (id, name) => {
    let res = await bankingService.generateBankingDocs(id);
    if (res?.data?.code === 200) {
      const base64Data = res?.data?.data?.fileInBytes;
      console.debug(base64Data);
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      // Save the blob as a file using FileSaver.js
      saveAs(blob, `${name}.docx`);
    }
  };

  return (
    <>
      {viewMoreModal && (
        <BankViewModal
          open={viewMoreModal}
          handleClose={() => setViewMoreModal(false)}
          data={viewData}
        />
      )}
      {isReceivedBankModal && (
        <ReceivedBankingRequests
          isOpen={isReceivedBankModal}
          selectedCardData={selectedCardData}
          closeReceivedBankModal={closeViewConnectionModal}
          getMatchingBankingListings={getMatchingBankingListings}
        />
      )}
      {isCurveModal && (
        <EnergyConsumptionCurve
          isOpen={isCurveModal}
          closeCurveModal={closeCurveModal}
        />
      )}
      {Boolean(isAddBankingRequest) && (
        <BankingRequestModal
          isOpen={isAddBankingRequest}
          selectedCardData={selectedCardData}
          closeAddsBidsModal={closeAddsBidsModal}
          getMatchingBankingListings={getMatchingBankingListings}
        />
      )}
      {isPdfOpen && (
        <UploadedDocument
          fileData={selectedFileData}
          handleCloseModal={handleClosePDFModal}
          fileType={selectedFiles}
          isOpen={isPdfOpen}
          download={true}
        />
      )}
      {isModel && (
        <BankingSlot
          isOpen={isModel}
          docData={docData}
          handleSubmit={handleEditClick}
          duplicate={duplicate}
        />
      )}
      {isOpenChat && (
        <Chat
          isOpen={isOpenChat}
          closeChatModal={() => {
            setOpenChat(false);
          }}
          UserCapName={UserCapName}
        />
      )}
      <div className={Styles.listingSection}>
        <div>
          <div className={Styles.ListingContainer}>
            <div className={Styles.myListText}>
              <div>My Banking</div>
              {/* <div
        className={Styles.consumptionCurve}
        onClick={() => openCurveModal()}
       >
        Energy Consumption Curve
       </div> */}
            </div>
            <div>
              <div className={Styles.listContainer}>
                <div className={Styles.layoutContainer01}>
                  {allBankListings?.length > 0
                    ? allBankListings?.map((bankItem, index) => {
                        const itemExpiryDate = moment(
                          `${bankItem?.remainingTime}`,
                          "DD-MMM-yyyy hh:mm A"
                        );
                        return (
                          <div
                            key={index}
                            onClick={() => handleSelectCard(bankItem, index)}
                            className={
                              selectedCardIndex === index
                                ? Styles.listMainContainerBankingActive
                                : Styles.listMainContainerBanking
                            }
                          >
                            <div className={Styles.detailsContainer}>
                              <div className={Styles.itemNameTextCont}>
                                <div className={Styles.itemNameText}>
                                  {bankItem?.name}
                                </div>
                              </div>
                              {checkRenderType(
                                bankItem?.bankingSlotInjects?.[0]?.dateStartAt,
                                bankItem?.bankingSlotDrawls?.[0]?.dateStartAt
                              ) ? (
                                <>
                                  <div className="dashboard-slot dashboard-slot-date-time justify-content-center">
                                    <div>
                                      <div>Injection</div>
                                    </div>
                                    <div>:</div>
                                    {renderSlotDetails(
                                      bankItem?.bankingSlotInjects,
                                      "injection",
                                      bankItem?.id,
                                      showDetails
                                    )}
                                    <a
                                      className={Styles.linkTextBanking}
                                      onClick={(e) =>
                                        handleShowDetails(
                                          "injection",
                                          bankItem?.id,
                                          e,
                                          bankItem
                                        )
                                      }
                                    >
                                      {showDetails["injection"]?.[bankItem?.id]
                                        ? "less"
                                        : "Details"}
                                    </a>
                                  </div>
                                  <div className="dashboard-slot dashboard-slot-date-time justify-content-center">
                                    <div>
                                      <div>Drawal</div>
                                    </div>
                                    <div>:</div>
                                    {renderSlotDetails(
                                      bankItem?.bankingSlotDrawls,
                                      "drawal",
                                      bankItem?.id,
                                      showDetails
                                    )}
                                    <a
                                      className={Styles.linkTextBanking}
                                      onClick={(e) => {
                                        handleShowDetails(
                                          "drawal",
                                          bankItem?.id,
                                          e,
                                          bankItem
                                        );
                                      }}
                                    >
                                      {showDetails["drawal"]?.[bankItem?.id]
                                        ? "less"
                                        : "Details"}
                                    </a>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="dashboard-slot dashboard-slot-date-time justify-content-center">
                                    <div>
                                      <div>Drawal</div>
                                    </div>
                                    <div>:</div>
                                    {renderSlotDetails(
                                      bankItem?.bankingSlotDrawls,
                                      "drawal",
                                      bankItem?.id,
                                      showDetails
                                    )}
                                    <a
                                      className={Styles.linkTextBanking}
                                      onClick={(e) => {
                                        handleShowDetails(
                                          "drawal",
                                          bankItem?.id,
                                          e,
                                          bankItem
                                        );
                                      }}
                                    >
                                      {showDetails["drawal"]?.[bankItem?.id]
                                        ? "less"
                                        : "Details"}
                                    </a>
                                  </div>
                                  <div className="dashboard-slot dashboard-slot-date-time justify-content-center">
                                    <div>
                                      <div>Injection</div>
                                    </div>
                                    <div>:</div>
                                    {renderSlotDetails(
                                      bankItem?.bankingSlotInjects,
                                      "injection",
                                      bankItem?.id,
                                      showDetails
                                    )}
                                    <a
                                      className={Styles.linkTextBanking}
                                      onClick={(e) =>
                                        handleShowDetails(
                                          "injection",
                                          bankItem?.id,
                                          e,
                                          bankItem
                                        )
                                      }
                                    >
                                      {showDetails["injection"]?.[bankItem?.id]
                                        ? "less"
                                        : "Details"}
                                    </a>
                                  </div>
                                </>
                              )}

                              <div className={Styles.quantityRateContainer}>
                                <div className={Styles.qtyPricText}>
                                  <div>Quantity (MW) :-</div>
                                  <div>{bankItem?.requiredQty}</div>
                                </div>
                                <div className={Styles.qtyPricText}>
                                  <div>BF (%) :-</div>
                                  <div>{bankItem?.bankingFactor}</div>
                                </div>
                                <div className={Styles.qtyPricText}>
                                  <div>SR (₹/KWH) :-</div>
                                  <div>{bankItem?.settlementRate}</div>
                                </div>
                                {bankItem?.tenderDocumentId && (
                                  <div className={Styles.qtyPricText}>
                                    <div>Terms and Conditions :-</div>
                                    <div
                                      onClick={(e) =>
                                        handleViewFile(
                                          bankItem?.tenderDocumentId,
                                          e
                                        )
                                      }
                                    >
                                      <RemoveRedEyeIcon
                                        style={{
                                          color: "#FF7D00",
                                          fontSize: "16px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div
                                className={
                                  bankItem?.isExpired
                                    ? Styles.expiesTextActive
                                    : Styles.expiesText
                                }
                              >
                                {bankItem?.isExpired ? (
                                  <div className={Styles.expContainer}>
                                    <span>Expires on:-</span>
                                    <CountDownTimer
                                      targetDate={itemExpiryDate}
                                      remTime={bankItem?.remainingTime}
                                      type="2"
                                    />
                                  </div>
                                ) : (
                                  <span>Expires on {bankItem?.expiryAt}</span>
                                )}
                              </div>
                            </div>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                              className={Styles.tagContainer}
                            >
                              {unreadNotificationsObj[bankItem?.name] ? (
                                <OverlayTrigger
                                  placement="right"
                                  overlay={
                                    <Tooltip>
                                      {unreadNotificationsObj[bankItem?.name] ||
                                        "Something went wrong will notify you"}
                                    </Tooltip>
                                  }
                                >
                                  <NotificationsActiveIcon
                                    style={{ fontSize: "20px" }}
                                  />
                                </OverlayTrigger>
                              ) : (
                                <NotificationsNoneIcon
                                  style={{ fontSize: "25px" }}
                                />
                              )}
                              <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip>Edit Listing</Tooltip>}
                              >
                                <div
                                  className={Styles.iconContainer}
                                  style={{ background: "#6610f2" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditClick(bankItem, "edit");
                                  }}
                                >
                                  <EditIcon
                                    style={{ fontSize: "20px", color: "#fff" }}
                                  />
                                </div>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip>View Received</Tooltip>}
                              >
                                <div
                                  className={Styles.iconContainer}
                                  style={{ background: "#198754" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleBankingsReceived(bankItem);
                                  }}
                                >
                                  <ListIcon
                                    style={{ fontSize: "20px", color: "#fff" }}
                                  />
                                </div>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip>Chats</Tooltip>}
                              >
                                <div
                                  className={Styles.iconContainer}
                                  style={{ background: "#fd7e14" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleChatClick(e, bankItem);
                                  }}
                                >
                                  <ChatIcon
                                    style={{ fontSize: "20px", color: "#fff" }}
                                  />
                                </div>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip>Duplicate</Tooltip>}
                              >
                                <div
                                  className={Styles.iconContainer}
                                  style={{
                                    border: "1px solid #fd7e14",
                                    background: "#fff",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditClick(bankItem, "duplicate");
                                  }}
                                >
                                  <ContentCopyIcon
                                    style={{
                                      fontSize: "20px",
                                      color: "#fd7e14",
                                    }}
                                  />
                                </div>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="right"
                                overlay={
                                  <Tooltip>Download Listing Details</Tooltip>
                                }
                              >
                                <div
                                  className={Styles.iconContainer}
                                  style={{
                                    border: "1px solid #fd7e14",
                                    background: "#fff",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDownloadListing(
                                      bankItem?.id,
                                      bankItem?.name
                                    );
                                  }}
                                >
                                  <Download
                                    style={{
                                      fontSize: "20px",
                                      color: "#fd7e14",
                                    }}
                                  />
                                </div>
                              </OverlayTrigger>
                              <Menu
                                id="long-menu"
                                MenuListProps={{
                                  "aria-labelledby": "long-button",
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={(e) => handleClose(e)}
                                PaperProps={{
                                  style: {
                                    maxHeight: 48 * 4.5,
                                    width: "30ch",
                                  },
                                }}
                              >
                                {acceptedCapData?.length > 0 ? (
                                  acceptedCapData?.map((capName) => (
                                    <MenuItem
                                      key={capName}
                                      onClick={(e) => {
                                        handleCapNameClick(e, capName);
                                      }}
                                    >
                                      {capName}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem
                                    onClick={(e) => {
                                      handleClose(e);
                                    }}
                                  >
                                    No Chats Initiated With this Listing
                                  </MenuItem>
                                )}
                              </Menu>
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </div>
                <div className={Styles.buttonCont}>
                  <div onClick={handleAddNewSlot} className={Styles.addButton}>
                    {/* <AddIcon style={{ fontSize: "20px", marginTop: "-2px", fontWeight:"900" }} /> */}
                    <i className="fa fa-plus me-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={Styles.avaiCont}>
          <div className={Styles.listimeMainCont}>
            {
              <div className={Styles.filterMainContainer}>
                <div className={Styles.availableListText}>
                  Available Listing : {matchingProfiles?.length}
                </div>
                <div className={Styles.qtyFitlerContainer}>
                  {sortingItems?.map((item, i) => (
                    <div
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSortClick(item.key)}
                      className={Styles.fiterButton}
                    >
                      {item.name}
                      {item.value === "DESC" && (
                        <ArrowDownwardIcon style={{ fontSize: "20px" }} />
                      )}
                      {item.value === "ASC" && (
                        <ArrowUpwardIcon style={{ fontSize: "20px" }} />
                      )}
                    </div>
                  ))}
                </div>
                <div>
                  <FilterListIcon
                    style={{ fontSize: "25px", color: "#5c79e0" }}
                  />
                  <select
                    name="connectionStatus"
                    value={statusDropDownValue}
                    onChange={(e) => {
                      handleFilterDropdown(e.target.value);
                    }}
                    className="custom-select-filters"
                  >
                    <option value="">All</option>
                    <option value="PLACED">Placed</option>
                    <option value="ACCEPTED">Connected</option>
                    <option value="REJECTED">Declined</option>
                  </select>
                </div>
                {
                  <div
                    className={Styles.filterButton}
                    // onClick={() => setFIlterModal(true)}
                  >
                    Filters
                  </div>
                }
              </div>
            }
            {loader ? (
              <div className="popup-background">
                <CircularProgress />
              </div>
            ) : (
              matchingProfiles?.length > 0 && (
                <div className={Styles.eachProfileSrctionMain}>
                  {matchingProfiles?.map((item, i) => {
                    const itemExpiryDate = moment(
                      `${item?.expiryAt}`,
                      "DD-MMM-yyyy hh:mm A"
                    );

                    return (
                      <div key={i} className={Styles.profilesMainContainer}>
                        <div className={Styles.headingLayer}>
                          <div className={Styles.detailsLine1}>
                            <img
                              className={Styles.companylogo}
                              src="images/com-profile-img-1.png"
                              alt="company profile"
                            />
                            <div className={Styles.companytitile}>
                              {item?.company?.companyName}
                            </div>
                            <div className={Styles.capacityName}>
                              - {item?.name}
                            </div>
                          </div>
                          {unreadNotificationsObj[item.name] ? (
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip>
                                  {unreadNotificationsObj[item.name]}
                                </Tooltip>
                              }
                            >
                              <NotificationsActiveIcon
                                style={{ fontSize: "20px" }}
                              />
                            </OverlayTrigger>
                          ) : (
                            <NotificationsNoneIcon
                              style={{ fontSize: "20px" }}
                            />
                          )}
                        </div>
                        <div className={Styles.listingDetailsMain}>
                          <div className={Styles.listingDetailsContainer}>
                            <div className={Styles.detailingData}>
                              <div>Region</div>
                              <div>{item?.company?.region}</div>
                            </div>
                            <div className={Styles.detailingData}>
                              <div>State</div>
                              <div>{item?.company?.state}</div>
                            </div>
                            <div className={Styles.detailingData}>
                              <div>Credit Rating</div>
                              <div>{item?.company?.creditRating} </div>
                            </div>
                            <div className={Styles.detailingData}>
                              <div>Quantity (MW)</div>
                              <div>{item?.requiredQty}</div>
                            </div>
                            {item?.tenderDocumentId && (
                              <div className={Styles.detailingData}>
                                <div>Terms and Condition</div>
                                <div
                                  style={{
                                    display: "flex",
                                    fontSize: "12px",
                                    alignItems: "center",
                                    border: "1px solid #FF7D00",
                                    padding: "5px",
                                    borderRadius: "8px",
                                    gap: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) =>
                                    handleViewFile(item?.tenderDocumentId, e)
                                  }
                                >
                                  <span>View</span>
                                  <RemoveRedEyeIcon
                                    style={{
                                      color: "#FF7D00",
                                      fontSize: "16px",
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                          <div className={Styles.listingDetailsContainer}>
                            <div className={Styles.detailingData}>
                              <div>Settlement Rate(₹/KWH)</div>
                              <div>{item?.settlementRate || "NA"}</div>
                            </div>
                            <div className={Styles.detailingData}>
                              <div>Banking Factor</div>
                              <div>{item?.bankingFactor || "NA"}</div>
                            </div>
                            <div className={Styles.detailingData}>
                              <div>Time Of Drawal Factor</div>
                              <div>{item?.timeOfDrawlFactor || "NA"}</div>
                            </div>
                            <div className={Styles.detailingData}>
                              <div>Injection And Drawal Range </div>
                              <div
                                onClick={(e) =>
                                  handleShowDetails("type", "index", e, item)
                                }
                                style={{cursor:"pointer",color:"#FF7D00"}}
                              >
                                Details
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={Styles.expairyContainer}>
                          <div className={Styles.expiringOnText}>
                            Expires on :-
                          </div>
                          <CountDownTimer targetDate={itemExpiryDate} />
                        </div>
                        <div className={Styles.alterSectionMain}>
                          <div
                            className={Styles.eachProfileSrction}
                            onClick={() => handleViewProfile(item)}
                          >
                            <PreviewIcon
                              style={{
                                height: "25px",
                                width: "25px",
                                color: "#FF7D00",
                              }}
                            />
                            <div style={{ color: "#FF7D00" }}>View Profile</div>
                          </div>
                          {item?.isEditable && (
                            <button
                              className={Styles.eachProfileSrction}
                              onClick={() => handleViewConnection(item)}
                              disabled={isButtonEnabled}
                            >
                              <RemoveRedEyeIcon
                                style={{ height: "25px", width: "25px" }}
                              />
                              <div style={{ textTransform: "capitalize" }}>
                                View {configKey}
                              </div>
                            </button>
                          )}
                          {!item?.isEditable && (
                            <div
                              className={Styles.eachProfileSrction}
                              onClick={() => handleAddBids(item)}
                            >
                              {item?.isEditable ? (
                                <WysiwygIcon
                                  style={{ height: "25px", width: "25px" }}
                                />
                              ) : (
                                <PersonAddIcon
                                  style={{ height: "25px", width: "25px" }}
                                />
                              )}
                              <div>Request to Connect</div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            )}
          </div>
          {
            <div className={Styles.filterSection}>
              <FilterSection
                selectedCardData={selectedCardData}
                getMatchingBankingListings={getMatchingBankingListings}
                // getMatchingProfilesCon={getMatchingProfilesCon}
                // getMatchingProfiles={getMatchingProfiles}
                // formResetFlag={formResetFlag}
              />
            </div>
          }
        </div>
      </div>
    </>
  );
};
